import { useAuth0 } from "@auth0/auth0-react"
import { useContext, useEffect, useMemo } from "react"
import { useLocation, useParams } from "react-router-dom"
import BifrostTab from "../../../../../Components/BifrostElementComponent/BifrostTab/BifrostTab"
import Loader from "../../../../../Components/BifrostPageComponent/Loader/Loader"
import BifrostAuditComponent from "../../../../../Components/BifrostPageComponent/OrganizationComponents/BifrostAuditComponent"
import BifrostEventComponent from "../../../../../Components/BifrostPageComponent/OrganizationComponents/BifrostEventComponent"
import { useGetUserById } from "../../../../../Hooks/FetchHooks/GetDataService/useGetDataById/useGetUserById"
import userInfoContext from "../../../../../store/userInfoContext"
import { hasFeatureInPackage, isSuperAdminOrResellerAdminOrAdmin } from "../../../../../Utils/util"
import Error401 from "../../../../OtherPages/ErrorPage/Error401"
import MainPanelHeader from "../../../MainPanelHeader/MainPanelHeader"
import UserDetails from "./UserDetails"
// import BifrostSessionComponent from '../../../../../Components/BifrostPageComponent/OrganizationComponents/BifrostSessionComponent';
import MainPanelFooter from "../../../MainPanelFooter/MainPanelFooter"

const UserDetailsPage = () => {
	const { id } = useParams()
	const { user } = useAuth0()
	const userInfo = useContext(userInfoContext)
	const { state } = useLocation()

	const { isLoading: userIsLoading, isError, data, setData, getUserById } = useGetUserById(id)

	const detailData = useMemo(() => {
		return [
			{
				tabName: "Details",
				feature: null,
				featureName: null,
				featureIcon: null,
				renderCondition: process.env.REACT_APP_SAML_ENABLED === "true",
				disabled: false,
				tabContent: <UserDetails data={data} setData={setData} refresh={getUserById} />
			},
			{
				tabName: "Audit",
				feature: hasFeatureInPackage(userInfo, "audit_log"),
				featureName: "audit_log",
				featureIcon: "history",
				disabled: !isSuperAdminOrResellerAdminOrAdmin(user),
				tabContent: <BifrostAuditComponent chosenItem={data} chosenItemType="user" />
			},
			{
				tabName: "Events",
				feature: hasFeatureInPackage(userInfo, "audit_log"),
				featureName: "audit_log",
				featureIcon: "calendar check",
				disabled: !isSuperAdminOrResellerAdminOrAdmin(user),
				tabContent: <BifrostEventComponent chosenItem={data} chosenItemType="user" />
			}
		]
	})

	const style = useMemo(() => {
		return {
			tabular: true,
			tabStyle: { paddingTop: "10px" },
			contentStyle: { padding: "20px" }
		}
	})

	useEffect(() => {
		if (id) {
			getUserById()
		}
	}, [id])

	return (
		<>
			<section className={"bifrost-table-panel devices-table"} data-testid={"user-details-page"}>
				<MainPanelHeader title={isError ? " " : "User"} name={userIsLoading ? (state ? state.name : "") : data.nickname} navPath={"/users"} />
				{userIsLoading ? (
					<Loader backgroundColor="white" inverted height="1px" minHeight="200px" />
				) : (
					<>{isError ? <Error401 backgroundColor="white" /> : <BifrostTab detailData={detailData} style={style} />}</>
				)}
				<MainPanelFooter />
			</section>
		</>
	)
}

export default UserDetailsPage
